// package
import { common, config } from "includes";
import { forwardRef, useEffect } from "react";
import { Button } from "react-bootstrap";

const Facebook = forwardRef((props: any, ref: any) => {

  // effect
  useEffect(() => {
    const initFacebookSDK = () => {
      (window as any).fbAsyncInit = () => {
        (window as any).FB.init({
          appId: config.fbAppId,
          cookie: true,
          xfbml: true,
          version: "v16.0",
        });
      };

      const script = document.createElement("script");
      script.src = "https://connect.facebook.net/en_US/sdk.js";
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    };

    initFacebookSDK();
  }, []);

  // event
  const handleFacebookLogin = (e: any) => {
    e.preventDefault();
    (window as any).FB.login(
      (response: any) => {
        console.log("================response", JSON.stringify(response));
        
        if (response.authResponse) {
          const accessToken = response.authResponse.accessToken;
          (window as any).FB.api(
            "/me/accounts",
            "GET",
            { access_token: accessToken },
            (pageResponse: any) => {
              if (pageResponse && !pageResponse.error) {
                let newData: any = [];
                pageResponse?.data.map((obj: any) =>
                  newData.push({
                    ...obj,
                    longLivedAccessToken: response.authResponse.accessToken,
                    longLivedTokenExpire: response.authResponse.expiresIn || response.authResponse.data_access_expiration_time,
                    createdAt: common.formatDate(new Date(), "YYYY-MM-DDTHH:mm", true)
                  })
                );
                console.log("==========newData", newData);
                
                props.setFBPage(newData);
              } else {
                console.error("Error fetching pages:", pageResponse.error);
              }
            }
          );
        } else {
          console.log("User cancelled login or did not fully authorize.");
        }
      },
      {
        scope: [
          "public_profile",
          "email",
          "pages_manage_posts",
          "pages_manage_metadata",
          "pages_read_engagement",
          "pages_read_user_content",
          "pages_show_list",
        ].join(","),
      }
    );
  };

  return (
    <div>
      <Button variant="primary" onClick={handleFacebookLogin}>Link a Facebook Page</Button>
    </div>
  );
});

export default Facebook;

